import React from 'react'

/**
 * 법적 문서(개인정보처리방침·이용약관·위치기반서비스 약관·마케팅 동의) 공통 레이아웃.
 * - 앱 셸(헤더/네비/탭바) 없이 문서만 렌더 → 웹뷰 [보기] 및 공개 URL(스토어 제출)용
 * - 배경 #f3efe6, 본문 #453d2c 80%, 제목·강조 #453d2c, max-width 640px, 줄간격 1.7
 * - 스타일은 .legal-doc 스코프로 한정(전역 오염 방지). 각 페이지는 시맨틱 HTML만 넣으면 됨.
 */
const LegalLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div style={{ minHeight: '100%', background: '#FAF6EF' }}>
      <div
        className="legal-doc"
        style={{
          maxWidth: 640,
          margin: '0 auto',
          padding: '32px 20px 24px',
          color: 'rgba(69, 61, 44, 0.8)',
          lineHeight: 1.7,
          fontSize: 15,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", "Pretendard", "Segoe UI", Roboto, sans-serif',
          WebkitFontSmoothing: 'antialiased',
        }}
      >
        <style>{`
          /* 굵은 글자(큰 제목 h1~h3, 강조 strong, 표 헤더)는 앱 표준 brown-80%(rgba(75,54,33,0.8))로 통일 */
          .legal-doc h1 { color:rgba(75,54,33,0.8); font-size:24px; font-weight:700; line-height:1.35; margin:0 0 8px; }
          .legal-doc h2 { color:rgba(75,54,33,0.8); font-size:18px; font-weight:700; margin:32px 0 10px; }
          .legal-doc h3 { color:rgba(75,54,33,0.8); font-size:16px; font-weight:700; margin:20px 0 8px; }
          .legal-doc p { margin:0 0 12px; }
          .legal-doc strong { color:rgba(75,54,33,0.8); font-weight:700; }
          /* 리스트: 1단계(제목·문단 바로 아래)는 마커·들여쓰기 없이 문단처럼 왼쪽 정렬.
             bullet·들여쓰기는 진짜 하위 목록(중첩)에만 — 2단계 •, 3단계 ◦ */
          .legal-doc ul { margin:0 0 12px; padding-left:0; list-style:none; }
          .legal-doc ul ul { margin:6px 0 4px; padding-left:20px; list-style:disc; }
          .legal-doc ul ul ul { list-style:circle; }
          /* 1단계라도 '열거형'이라 bullet이 나은 목록엔 className="bullets" */
          .legal-doc ul.bullets { padding-left:20px; list-style:disc; }
          .legal-doc li { margin:0 0 6px; }
          .legal-doc li::marker { color:rgba(75,54,33,0.55); }
          .legal-doc a { color:rgba(75,54,33,0.8); }
          .legal-doc .legal-eff { color:rgba(69,61,44,0.6); font-size:14px; margin:0 0 20px; }
          .legal-doc table { width:100%; border-collapse:collapse; margin:8px 0 14px; font-size:14px; }
          .legal-doc th, .legal-doc td { border:1px solid rgba(69,61,44,0.2); padding:10px; text-align:left; vertical-align:top; }
          .legal-doc thead th, .legal-doc tbody th { background:rgba(69,61,44,0.06); color:rgba(75,54,33,0.8); font-weight:700; }
          .legal-doc .legal-footer { margin-top:28px; padding-top:20px; border-top:1px solid rgba(69,61,44,0.2); font-size:13px; color:rgba(69,61,44,0.6); line-height:1.9; }
        `}</style>

        {children}

        <div className="legal-footer">
          상호: (주)미디어인터랙티브
          <br />
          대표: 김경민
          <br />
          사업자등록번호: 140-81-44663
          <br />
          주소: 경기도 하남시 미사대로 520, CA동 1031호
          <br />
          이메일: admin@tastee.kr
        </div>
      </div>
    </div>
  )
}

export default LegalLayout
